/** Whose work to show: Me · each teammate · Everyone. */
import { Segmented, firstName } from "@/features/command/ui";
import type { Me } from "./lib";
import type { Person } from "./types";

export type PersonKey = string; // "me" | "all" | a person id

export function PersonSwitch({
  value, onChange, people, me, size = "md",
}: { value: PersonKey; onChange: (v: PersonKey) => void; people: Person[]; me: Me | null; size?: "sm" | "md" }) {
  const meIsTeam = !!me && people.some((p) => p.id === me.id);
  const options = [
    ...(meIsTeam ? [{ value: "me", label: "Me" }] : []),
    ...people.filter((p) => !meIsTeam || p.id !== me!.id).map((p) => ({ value: p.id, label: firstName(p.name) })),
    { value: "all", label: "Everyone" },
  ];
  // A stored "me" on a computer where "me" isn't a teammate shows as Everyone.
  const shown = options.some((o) => o.value === value) ? value : "all";
  return <Segmented size={size} value={shown} onChange={onChange} options={options} />;
}

/** The assignee id a switch value means (undefined = everyone). */
export function personId(value: PersonKey, me: Me | null, people: Person[]): string | undefined {
  if (value === "all") return undefined;
  if (value === "me") return me && people.some((p) => p.id === me.id) ? me.id : undefined;
  return people.some((p) => p.id === value) ? value : undefined;
}

const KEY = "cc.work.person";
export function storedPerson(): PersonKey {
  try { return localStorage.getItem(KEY) || "me"; } catch { return "me"; }
}
export function storePerson(v: PersonKey): void {
  try { localStorage.setItem(KEY, v); } catch { /* private mode */ }
}
